module.exports = __webpack_public_path__ + "img/5.68153d5e.jpg";